import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  BackendService,
  // SAVE_FORM
} from './../shared/index';

@Injectable()
export class CVFormService {
  appEnv;

  constructor(
    private _store: Store<any>,
    private _backend: BackendService
  ) {}

  setAppEnv(appEnv) {
    this.appEnv = appEnv;
  }

  sendToServerAndUpdateStore(formId, formValue, completed?: boolean): Promise<any> {
    return this._backend.setFormData(formId, formValue, completed);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/coverage-form.service.ts